<mat-dialog-content class="dialogcontent flexcolumn">

  @if (batch) {
    <ng-container class="pagecontent">
      <fieldset>
        @if (dialogdata.mode==='FSE') {
          <legend>Détails du lot FSE </legend>
        }
        @if (dialogdata.mode==='DRE') {
          <legend>Détails du lot DRE</legend>
        }
        <div class="flexrow">
          <span class="title">Référence Lot</span>
          <div class="flexrow" style="width: 100%;">
            <span class="value">{{ batch.ref_lot }}</span>
            <span style="font-size: small; color: grey; text-align: end; width: 100%;">#{{ batch.id }}</span>
          </div>
        </div>
        <div class="flexrow">
          <span class="title">Date du Lot</span>
          <span class="value">{{ batch.date_lot | date:'dd/MM/yyyy':'':'fr' }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Id. Facturation</span>
          <span class="value">{{ batch.num_ident_fact }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Id. Signataire</span>
          <span class="value">{{ batch.num_ident_signataire }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Org. Destinataire</span>
          <span class="value">{{ batch.num_orga_dest }}</span>
        </div>
        <div class="flexrow">
          <span class="title">État du Lot</span>
          <span class="value">{{ batch.etat_lot }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Date du Dernier État</span>
          <span class="value">{{ batch.date_heure_etat_lot | date:'dd/MM/yyyy':'':'fr' }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Diagnostic Anomalie</span>
          <span class="value">{{ batch.diag_anomalie }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Traitement Anomalie</span>
          <span class="value">{{ batch.trait_anomalie }}</span>
        </div>
      </fieldset>
    </ng-container>
  }

  @if (rsps) {
    @for (r of rsps; track r; let i = $index) {
      <fieldset>
        <legend>RSP {{ dialogdata.mode }} {{ i+1 }}</legend>
        <!-- RSP entries -->
        @if (r.numFacture; as val) {
          <div class="flexrow">
            <span class="title">N° Facture</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        <div class="flexrow">
          <span class="title">Date Comptable</span>
          <span class="value">{{ r.dateComptable  | dateShortFr }}</span>
        </div>
        @if (r.refLot; as val) {
          <div class="flexrow">
            <span class="title">Référence Lot</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        @if (r.dateLot | dateShortFr; as val) {
          <div class="flexrow">
            <span class="title">Date Lot</span>
            <!-- dateLot in your example is '011025' (ddmmyy); show raw for now -->
            <span class="value">{{ val }}</span>
          </div>
        }
        @if (r.dateFacture | dateShortFr; as val) {
          <div class="flexrow">
            <span class="title">Date Facture</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        @if (r.numSecu; as val) {
          <div class="flexrow">
            <span class="title">NIR</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        @if (r.dateNaissBenef; as val) {
          <div class="flexrow">
            <span class="title">Date - Rang Naissance</span>
            <span class="value">{{ val | dateShortFr }}@if (r.rangNaiss; as val) {
              <span>&nbsp;-&nbsp;{{ val }}</span>
            } </span>
          </div>
        }
        @if (r.nomBenef; as val) {
          <div class="flexrow">
            <span class="title">Nom</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        @if (r.prenomBenef; as val) {
          <div class="flexrow">
            <span class="title">Prénom</span>
            <span class="value">{{ val }}</span>
          </div>
        }
        <div class="flexrow">
          <span class="title">Type Retour</span>
          <span class="value">{{ stateHelper.typeRetourLabels[r.typeRetour] }}</span>
        </div>
        @if (r.risque) {
          <div class="flexrow">
            <span class="title">Risque</span>
            <span class="value">{{ stateHelper.risque[r.risque] || r.risque }}</span>
          </div>
        }
        <div class="flexrow">
          <span class="title">Lib. Vir. 1</span>
          <span class="value">{{ r.libVirement1 }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Lib. Vir. 2</span>
          <span class="value">{{ r.libVirement2 }}</span>
        </div>
        @if (r.traitementPartAMC; as val) {
          <div class="flexrow">
            <span class="title">Trait. Part AMC</span>
            <span class="value">{{ stateHelper.traitementPartAMC[val] || val }}</span>
          </div>
        }
        <div class="flexrow">
          <span class="title">Total Paiement</span>
          <span class="value">{{ +(r.totalPaiement) / 100 }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Total AMO</span>
          <span class="value">{{ +(r.totalAMO??0) / 100 }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Total AMC</span>
          <span class="value">{{ +(r.totalAMC??0) / 100 }}</span>
        </div>
        @if (r.premierRejet) {
          <div class="flexrow">
            <span class="title">Premier Rejet</span>
            <span class="value">{{ r.premierRejet }}</span>
          </div>
        }
        <div class="flexrow">
          <span class="title">Top Paiement</span>
          <span class="value">{{ r.topPaiement }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Top Rejet</span>
          <span class="value">{{ r.topRejet }}</span>
        </div>
        <div class="flexrow">
          <span class="title">Top Différé</span>
          <span class="value">{{ r.topDiffere }}</span>
        </div>
        @if (r.partAMO?.traitement) {
          <fieldset>
            <legend>Part AMO</legend>
            @if (stateHelper.getEtatRsp(r, true); as etatAmo) {
              <div class="flexrow">
                <span class="title">Traitement</span>
                <span class="value" [ngClass]="etatAmo.class">{{ etatAmo.label }}</span>
              </div>
            }
            <div class="flexrow">
              <span class="title">Montant demandé</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.partAMO?.montantDemande??0) / 100 }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Montant Paiement</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.partAMO?.montantPaiement??0) / 100 }}</span>
            </div>
          </fieldset>
        }
        @if (r.partAMC?.traitement) {
          <fieldset>
            <legend>Part AMC</legend>
            @if (stateHelper.getEtatRsp(r, false); as etatAmc) {
              <div class="flexrow">
                <span class="title">Traitement</span>
                <span class="value" [ngClass]="etatAmc.class">{{ etatAmc.label }}</span>
              </div>
            }
            <div class="flexrow">
              <span class="title">Montant demandé</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.partAMC?.montantDemande??0) / 100 }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Montant Paiement</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.partAMC?.montantPaiement??0) / 100 }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Id Adherent</span>
              <span class="value">&nbsp;&nbsp;{{ r.partAMC?.idAdherent }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Num Dest AMC</span>
              <span class="value">&nbsp;&nbsp;{{ r.partAMC?.numDestAMC }}</span>
            </div>
          </fieldset>
        }
        @if (r.rejet?.length) {
          <div class="rejets-block">
            <div class="title">Rejets</div>
            <ul>
              @for (rej of r.rejet; track rej) {
                <li>
                  <strong>{{ rej.code }}</strong> — {{ rej.libelle }}
                </li>
              }
            </ul>
          </div>
        }
        @if (r.MFI;) {
          <fieldset>
            <legend>Mvt. Financier</legend>
            <div class="flexrow">
              <span class="title">Réf. Dette</span>
              <span class="value">&nbsp;&nbsp;{{ r.MFI.refDette }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Date Dette</span>
              <span class="value">&nbsp;&nbsp;{{ r.MFI.dateDette | dateShortFr }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Nat. Dette</span>
              <span class="value">&nbsp;&nbsp;{{ stateHelper.natureDetteLabels[r.MFI.natureDette] }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Nat. Opé.</span>
              <span class="value">&nbsp;&nbsp;{{ stateHelper.natureOperationLabels[r.MFI.natureOperation] }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Montant</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.MFI.montantMFI)/100 }}</span>
            </div>
            <div class="flexrow">
              <span class="title">Solde</span>
              <span class="value">&nbsp;&nbsp;{{ +(r.MFI.montantSolde??0)/100 }}</span>
            </div>
          </fieldset>
        }
      </fieldset>
    }
  }
</mat-dialog-content>
